import Enllac from 'components/3catinfo/Enllac';
import Icona from 'components/3catinfo/ui/Icona';
import styles from './destacattext.module.scss';

const DestacatText = (props) => {
    const { item, mostraIconaFletxa = true, tag = 'h3' } = props;
    const Tag = tag;
    const route = {
        slug: item.permatitle || item.titol,
        id: item.id,
        tipologia: item.tipologia,
        domini: item.domini
    };
    return (
        <div className={styles.cardMosaicFaq}>
            <Enllac route={route}>
                <div className={styles.titolItem}>
                    <Tag>{item.titol}</Tag>
                </div>
                {mostraIconaFletxa && <Icona className={styles.iconaMosaicCards} icona={'fletxa_simple_dreta'} mida={30} />}
            </Enllac>
        </div>
    );
};

export default DestacatText;
